import type { ButtonProps } from "@components/core/Button";

import { Button } from "@components/core/Button";
import { Popover, PopoverContent, PopoverTrigger } from "@components/core/Popover";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@components/core/Tooltip";
import Info16 from "@ui/icons/16x16/info-16.svg";
import { cn } from "@ui/lib/utils";
import * as React from "react";
import { RichText } from "@components/core/RichText";

const InfoIconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...props }, ref) => {
  return (
    <Button
      aria-label='Learn more'
      className={cn("ml-4 text-lighter hover:text-default", className)}
      icon={<Info16 />}
      size='pill-sm'
      variant='ghost'
      {...props}
      ref={ref}
    />
  );
});

InfoIconButton.displayName = "InfoIconButton";

const RichTextContent = ({ tooltip }: { tooltip: string }) => {
  return <RichText content={tooltip} size='2xs' />;
};

export const PricingTooltip = ({
  tooltip,
  size = "sm",
  tooltipElement,
}: {
  size?: "sm" | "xs";
  tooltip: string;
  tooltipElement?: React.ReactNode;
}) => {
  return (
    <>
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <InfoIconButton className={cn("hidden lg:flex", size === "xs" ? "w-16" : "")} />
          </TooltipTrigger>
          <TooltipContent className='max-w-[300px]'>
            {tooltipElement ?? <RichTextContent tooltip={tooltip} />}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <Popover>
        <PopoverTrigger asChild>
          <InfoIconButton className='lg:hidden' />
        </PopoverTrigger>
        <PopoverContent className='w-[300px] max-w-[300px] bg-default' side='top'>
          {tooltipElement ?? <RichTextContent tooltip={tooltip} />}
        </PopoverContent>
      </Popover>
    </>
  );
};
